export default __webpack_public_path__ + "static/assets/84043284d2bf8d98eaf8e28874d05e5e.png";